import authService from '../../../core/services/AuthServices';
import { action, observable } from 'mobx';
import { showToastNotification } from 'welltrax-ui-components';

export class SocketConnection {
  @observable socketConnection: WebSocket | null;
  @observable errorCallBack: (() => void) | null;

  private manualClose: boolean;
  private maxRetryConection: number;
  private errorRetry: number;

  constructor() {
    this.socketConnection = null;
    this.errorCallBack = null;
    this.maxRetryConection = Number(process.env?.REACT_APP_SOCKET_RETRY_CONECTION ?? 10);
    this.manualClose = false;
    this.errorRetry = 0;
  }

  @action setErrorCallBack = (errorCallBack: (() => void) | null) => {
    this.errorCallBack = errorCallBack;
  };

  public reconnect = () => setInterval(this.check, 1000);

  static get socketUrl() {
    const orgName = authService.getUser()?.org.name || '';
    return `${process.env.REACT_APP_SOCKET_URL}${orgName}`;
  }

  check = () => {
    if (!this.socketConnection || this.socketConnection.readyState === WebSocket.CLOSED) {
      if (this.isPossibleReconnect()) {
        this.addIntent();
        this.connect();
      } else {
        clearTimeout(this.reconnect());
      }
    }
  };

  @action connect = () => {
    this.setManualClose(false);
    this.socketConnection = new WebSocket(SocketConnection.socketUrl);
    this.socketConnection.onopen = () => {
      this.sendMessage();
      clearTimeout(this.reconnect());
    };

    this.socketConnection.onerror = e => {
      this.socketConnection?.close?.();
    };

    this.socketConnection.onclose = e => {
      this.socketConnection = null;
      this.reconnect();
    };

    this.socketConnection.onmessage = this.processMessage;
  };

  public close = () => {
    this.socketConnection?.close();
    this.setManualClose(true);
  };

  public sendMessage = () => {
    this.socketConnection?.send?.(JSON.stringify({ message: 'MESSAGE' }));
  };

  public setManualClose(isManual: boolean) {
    this.manualClose = isManual;
  }

  public setErrorRetry(interval: number) {
    this.errorRetry = interval;
  }

  public addIntent() {
    this.setErrorRetry(this.errorRetry + 1);
  }

  public isPossibleReconnect() {
    return !this.manualClose && this.errorRetry < this.maxRetryConection;
  }

  processMessage = (message: MessageEvent) => {
    const data = message.data;
    try {
      const messageParsed = JSON.parse(data);
      if (messageParsed?.content && typeof messageParsed?.content === 'string') {
        showToastNotification({
          type: 'primary',
          icon: 'info-sign',
          message: messageParsed?.content
        });
      } else if (messageParsed?.content?.type === 'error' && typeof messageParsed?.content?.content === 'string') {
        if (this.errorCallBack) {
          this.errorCallBack();
        }
        showToastNotification({
          type: 'danger',
          icon: 'error',
          message: messageParsed?.content?.content
        });
      }
    } catch (e) {
      throw e;
    }
  };
}
